import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store, { key } from './store'
import "@/styles/index.css"
import '@material-design-icons/font';
import 'material-symbols';
import VueSignaturePad from 'vue-signature-pad';
import Middleware from './router/Middleware'
import VuePdf from 'vue3-pdfjs'
import VueTheMask from 'vue-the-mask'
import VueSimpleAlert from "vue3-simple-alert-next";
import { GeoLocationService } from './services/GeolocationService'

window.addEventListener('popstate', () => {
    Middleware.validaChecklistFinalizado()
})

GeoLocationService.obterGeolocalizacao();

createApp(App)
    .use(store, key)
    .use(router)
    .use(VueSignaturePad)
    .use(VuePdf)
    .use(VueTheMask)
    .use(VueSimpleAlert)
    .mount('#app')
